import { type ReactNode } from 'react'
import { createPortal } from 'react-dom'

export interface PortalProps {
  children: ReactNode
}

/**
 * The Portal
 */
export function Portal({ children }: PortalProps) {
  const container = globalThis?.document?.body
  return (
    container ? createPortal(<>{children}</>, container) : null
  ) as ReactNode
}
